import React, { useState } from "react";
import Styles from "../Prescription/Prescription.module.css";
import { host } from "../../link"
import Axios from "axios"
import { useSelector } from "react-redux";

const DoctorAdvice = () => {
    const [advice, setNewAdvice] = useState([{ Advice: "" }])
    const [diagnosis, setNewDiagnosis] = useState("")
    const auth = useSelector((state) => state.AuthReducer);
    // handle input change
    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const list = [...advice];
        list[index][name] = value;
        setNewAdvice(list);
    };

    // handle click event of the Remove button
    const handleRemoveClick = (index) => {
        const list = [...advice];
        list.splice(index, 1);
        setNewAdvice(list);
    };

    // handle click event of the Add button
    const handleAddClick = () => {
        setNewAdvice([...advice, { Advice: "" }]);
    };
    const handleSubmit = () => {
        const data = { diagnosis, advice }
        const headers = {
            "Content-Type": "application/json",
            authorization: `Bearer ${auth.token}`,
        };
        console.log(data)
        Axios.post(`${host}api/prescription/newAdvicefromDoctor`, data, { headers })
            .then(res => {
                console.log(res);
                setNewAdvice([{ Advice: "" }])
                setNewDiagnosis("")
                alert("Successfully Added!!!");
            })
            .catch(err => {
                alert("Something Went Wrong!");
            })
    }
    return (
        <>
            <h3>Doctor's Advice</h3>
            <form >
                <div>
                    <label htmlFor="Diagnosis_Name">Diagnosis Name</label>
                    <div className="col-6 mb-3">
                        <input
                            name="Diagnosis_Name"
                            type="text"
                            placeholder="Diagnosis Name"
                            className="form-control"
                            id="Diagnosis_Name"
                            value={diagnosis}
                            onChange={e => setNewDiagnosis(e.target.value)}
                            required
                        />
                    </div>
                    <label htmlFor="Advice"> Advice of Diagnosis</label>

                    {
                        advice.map((item, index) => {

                            return (
                                <div className="d-flex">
                                    <div className="col-md-6 mb-2">
                                        <input
                                            name="Advice"
                                            type="text"
                                            className="form-control "
                                            id="advice"
                                            placeholder="Advice of Diagnois"
                                            value={item.Advice}
                                            onChange={(e) => handleInputChange(e, index)}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-3 d-flex">
                                        {advice.length !== 1 && (
                                            <button
                                                className={Styles.removeButton}
                                                onClick={(i) => handleRemoveClick(i)}
                                            >
                                                <i className="fa fa-trash" aria-hidden="true"></i>
                                            </button>
                                        )}
                                        {advice.length - 1 === index && (
                                            <button
                                                className={Styles.addButton}
                                                onClick={handleAddClick}
                                            >
                                                <i className="fa fa-plus" aria-hidden="true"></i>
                                            </button>
                                        )}
                                    </div>
                                </div>
                            )
                        })
                    }
                    <button
                        type="button"
                        class="btn btn-primary"
                        onClick={handleSubmit}
                    >Save</button>

                </div>
            </form>
        </>
    )
}
export default DoctorAdvice